import { render, staticRenderFns } from "./ArchivePopup.vue?vue&type=template&id=21b2c720"
import script from "./ArchivePopup.vue?vue&type=script&lang=ts"
export * from "./ArchivePopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports